import { jsxs as P, Fragment as R, jsx as l } from "react/jsx-runtime";
import { FileSelectorModal as Z } from "@systemeio/file-manager";
import { Tooltip as h, FormInput as $ } from "@systemeio/ui";
import { CheckIcon as ee } from "@systemeio/ui/icons";
import { useEditorState as ne } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useState as A, useRef as z, useEffect as N, useCallback as V } from "react";
import { twJoin as a, twMerge as ie } from "tailwind-merge";
import { ToolbarButton as p } from "../../components/content-controls/toolbar-button.mjs";
import { TOOLTIP_STYLES as M, getToolbarIconClassName as le } from "../../constants/default-styles.mjs";
import { useTranslation as te } from "../../i18n.mjs";
import oe from "../../icons/caption-icon.mjs";
import ae from "../../icons/heading-icon.mjs";
import re from "../../icons/image-centered-icon.mjs";
import ce from "../../icons/image-inline-icon.mjs";
import se from "../../icons/image-side-icon.mjs";
import me from "../../icons/link-icon.mjs";
import de from "../../icons/phone-size-icon.mjs";
import { LinkBubbleEdit as ue, LinkBubbleView as pe } from "../link-extension/link-bubble-state.mjs";
import { ImageBubbleMenuState as n, ImageModeEnum as c } from "./image-enum.mjs";
import { isImageSelected as be } from "./utils/is-image-selected.mjs";
import { BubbleMenu as fe } from "../../components/bubble-menu/BubbleMenu.mjs";
const O = (i) => ({
  [n.EditAltMode]: (i == null ? void 0 : i.alt) ?? "",
  [n.EditLinkMode]: (i == null ? void 0 : i.href) ?? "",
  [n.EditCaptionMode]: (i == null ? void 0 : i.caption) ?? ""
}), he = (i) => i === n.EditAltMode || i === n.EditCaptionMode || i === n.EditLinkMode, Me = (i, g) => i[n.EditAltMode] === g[n.EditAltMode] && i[n.EditLinkMode] === g[n.EditLinkMode] && i[n.EditCaptionMode] === g[n.EditCaptionMode], We = ({ editor: i, fileSource: g, options: _ }) => {
  const { t: s } = te(), [y, F] = A(O()), [m, d] = A(
    n.InitialMode
  ), [W, v] = A(!1), [k, H] = A(!1), j = z(n.InitialMode), C = z({
    alt: null,
    href: null,
    caption: null
  }), t = ne({
    editor: i,
    selector: ({ editor: e }) => {
      var q;
      const o = e == null ? void 0 : e.state, u = o == null ? void 0 : o.selection.from, r = (q = o == null ? void 0 : o.doc.nodeAt(u ?? 0)) == null ? void 0 : q.type.name;
      return {
        from: u,
        node: r,
        imageMode: r ? e == null ? void 0 : e.getAttributes(r).imageMode : null,
        isMobileFullWidth: r ? e == null ? void 0 : e.getAttributes(r).isMobileFullWidth : !1,
        alt: r ? e == null ? void 0 : e.getAttributes(r).alt : null,
        href: r ? e == null ? void 0 : e.getAttributes(r).href : null,
        caption: r ? e == null ? void 0 : e.getAttributes(r).caption : null
      };
    }
  }), D = t == null ? void 0 : t.from, w = t == null ? void 0 : t.node, b = (t == null ? void 0 : t.imageMode) ?? null, x = (t == null ? void 0 : t.isMobileFullWidth) ?? !1, I = (t == null ? void 0 : t.alt) ?? null, f = (t == null ? void 0 : t.href) ?? null, E = (t == null ? void 0 : t.caption) ?? null;
  N(() => {
    j.current = m;
  }, [m]), N(() => {
    C.current = {
      alt: I,
      href: f,
      caption: E
    };
  }, [I, f, E]);
  const L = V((e) => {
    F(
      (o) => Me(o, e) ? o : e
    );
  }, []);
  N(() => {
    d(n.InitialMode);
    const e = O(C.current);
    L(e);
  }, [D, L]), N(() => {
    const e = O({
      alt: I,
      href: f,
      caption: E
    });
    L(e);
  }, [I, f, E, L]);
  const S = V(
    (e) => w ? (i == null || i.chain().focus().updateAttributes(w, e).run(), !0) : !1,
    [i, w]
  ), B = V(
    (e) => {
      i == null || i.chain().focus().toggleImageMode(e).run();
    },
    [i]
  );
  if (!i || !(i != null && i.options.editable)) return null;
  const J = (e, o) => {
    F((u) => ({ ...u, [e]: o }));
  }, T = (e, o) => {
    e === n.InitialMode || e === n.ViewLinkMode || S({ [e]: o }) && d(n.InitialMode);
  }, K = (e) => {
    S({ [e]: null }) && d(n.InitialMode);
  }, Y = () => {
    b === c.Inline && B(c.BlockCenter), setTimeout(() => {
      d(n.EditCaptionMode);
    }, 0);
  }, G = () => {
    S({ isMobileFullWidth: !x });
  }, Q = (e) => {
    switch (e) {
      case n.EditAltMode:
        return C.current.alt ?? "";
      case n.EditCaptionMode:
        return C.current.caption ?? "";
      case n.EditLinkMode:
        return C.current.href ?? "";
      default:
        return "";
    }
  }, U = () => {
    switch (m) {
      case n.ViewLinkMode:
        return /* @__PURE__ */ l(
          pe,
          {
            href: y[n.EditLinkMode],
            unsetLink: () => K(n.EditLinkMode),
            setIsEditing: () => d(n.EditLinkMode)
          }
        );
      case n.EditLinkMode:
        return /* @__PURE__ */ l(
          ue,
          {
            initialValue: y[n.EditLinkMode],
            onSaveLink: (e) => T(n.EditLinkMode, e),
            openFileSelector: () => {
              v(!0);
            },
            schemeOptions: _ == null ? void 0 : _.schemeOptions
          },
          y[n.EditLinkMode]
        );
      case n.EditCaptionMode:
      case n.EditAltMode: {
        const e = y[m];
        let o = "";
        switch (m) {
          case n.EditCaptionMode: {
            o = s("caption");
            break;
          }
          case n.EditAltMode:
            o = s("alt_text");
            break;
        }
        return /* @__PURE__ */ P(R, { children: [
          /* @__PURE__ */ l(
            $,
            {
              placeholder: o,
              value: e,
              onChange: (u) => J(m, u.target.value)
            }
          ),
          /* @__PURE__ */ l(p, { type: "submit", onClick: () => T(m, e), children: /* @__PURE__ */ l(ee, { className: le(!1) }) })
        ] });
      }
      case n.InitialMode:
      default:
        return /* @__PURE__ */ P(R, { children: [
          /* @__PURE__ */ l(
            h,
            {
              label: s("image_in_line"),
              anchor: "left",
              disabled: k,
              ...M,
              children: /* @__PURE__ */ l(
                p,
                {
                  onClick: () => B(c.Inline),
                  className: a(b === c.Inline && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ l(
                    ce,
                    {
                      className: a(
                        b === c.Inline ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                        "main-transition-colors"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ l(
            h,
            {
              label: s("image_center"),
              anchor: "left",
              disabled: k,
              ...M,
              children: /* @__PURE__ */ l(
                p,
                {
                  onClick: () => B(c.BlockCenter),
                  className: a(b === c.BlockCenter && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ l(
                    re,
                    {
                      className: a(
                        b === c.BlockCenter ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                        "main-transition-colors"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ l(h, { label: s("image_side"), anchor: "left", disabled: k, ...M, children: /* @__PURE__ */ l(
            p,
            {
              onClick: () => B(c.BlockRight),
              className: a(b === c.BlockRight && "bg-brand-primary/10"),
              children: /* @__PURE__ */ l(
                se,
                {
                  className: a(
                    b === c.BlockRight ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                    "main-transition-colors"
                  )
                }
              )
            }
          ) }),
          /* @__PURE__ */ l(
            h,
            {
              disabled: k,
              label: s("image_change_alt_text"),
              anchor: "left",
              ...M,
              children: /* @__PURE__ */ l(
                p,
                {
                  onClick: () => d(n.EditAltMode),
                  className: a(!!I && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ l(
                    ae,
                    {
                      className: a(
                        "main-transition-colors",
                        I ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ l(h, { label: s("image_change_caption"), anchor: "left", ...M, children: /* @__PURE__ */ l(
            p,
            {
              className: a(!!E && "bg-brand-primary/10"),
              onClick: Y,
              children: /* @__PURE__ */ l(
                oe,
                {
                  className: a(
                    E ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                    "main-transition-colors"
                  )
                }
              )
            }
          ) }),
          /* @__PURE__ */ l(
            h,
            {
              disabled: k,
              label: s("image_change_link"),
              anchor: "left",
              ...M,
              children: /* @__PURE__ */ l(
                p,
                {
                  className: a("main-transition-colors", !!f && "bg-brand-primary/10"),
                  onClick: () => d(
                    f ? n.ViewLinkMode : n.EditLinkMode
                  ),
                  children: /* @__PURE__ */ l(
                    me,
                    {
                      className: a(
                        "main-transition-colors",
                        f ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ l(
            h,
            {
              disabled: k,
              label: s("image_change_mobile_full_width"),
              anchor: "left",
              ...M,
              children: /* @__PURE__ */ l(
                p,
                {
                  className: a(
                    "main-transition-colors",
                    x && "bg-brand-primary/10"
                  ),
                  onClick: G,
                  children: /* @__PURE__ */ l(
                    de,
                    {
                      className: a(
                        "main-transition-colors",
                        x ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          )
        ] });
    }
  }, X = (e) => {
    if (he(e)) {
      const o = Q(e);
      F((u) => ({
        ...u,
        [e]: o
      }));
    }
  };
  return /* @__PURE__ */ P(R, { children: [
    /* @__PURE__ */ l(
      fe,
      {
        className: a(W && "hidden"),
        editor: i,
        pluginKey: "imageBubbleMenu",
        options: {
          onHide: () => {
            const e = j.current;
            X(e), d(n.InitialMode), H(!0);
          },
          onShow: () => {
            H(!1);
          }
        },
        shouldShow: ({ editor: e }) => be(e),
        children: /* @__PURE__ */ l(
          "form",
          {
            onSubmit: (e) => e.preventDefault(),
            className: ie(
              "flex items-center p-2",
              m === n.InitialMode && "gap-0.5"
            ),
            children: U()
          }
        )
      }
    ),
    /* @__PURE__ */ l(
      Z,
      {
        uploadingFromSource: g,
        initialSearchFilters: {
          source: [g],
          name: "",
          type: []
        },
        opened: W,
        onClose: () => v(!1),
        onSelect: (e) => {
          T(n.EditLinkMode, e.path), v(!1);
        }
      }
    )
  ] });
};
export {
  We as ImageBubbleMenu
};
